function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.VueIziToast = e() : t.VueIziToast = e();
}("undefined" != typeof self ? self : this, function () {
  return function (t) {
    var e = {};

    function i(o) {
      if (e[o]) return e[o].exports;
      var n = e[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return t[o].call(n.exports, n, n.exports, i), n.l = !0, n.exports;
    }

    return i.m = t, i.c = e, i.d = function (t, e, o) {
      i.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: o
      });
    }, i.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, i.t = function (t, e) {
      if (1 & e && (t = i(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var o = Object.create(null);
      if (i.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var n in t) {
        i.d(o, n, function (e) {
          return t[e];
        }.bind(null, n));
      }
      return o;
    }, i.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return i.d(e, "a", e), e;
    }, i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, i.p = "", i(i.s = 4);
  }([function (t, e) {
    t.exports = function (t, e, i) {
      return e in t ? Object.defineProperty(t, e, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = i, t;
    };
  }, function (t, e) {
    function i(t, e) {
      for (var i = 0; i < e.length; i++) {
        var o = e[i];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
      }
    }

    t.exports = function (t, e, o) {
      return e && i(t.prototype, e), o && i(t, o), t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (t, e, i) {
    (function (i) {
      var o, n, s;
      void 0 !== i || window || this.window || this.global, n = [], o = function (t) {
        "use strict";

        var e = {},
            i = (document.querySelector("body"), !!/Mobi/.test(navigator.userAgent)),
            o = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor),
            n = "undefined" != typeof InstallTrigger,
            s = ("ontouchstart" in document.documentElement),
            a = ["bottomRight", "bottomLeft", "bottomCenter", "topRight", "topLeft", "topCenter", "center"],
            r = {};
        e.children = {};
        var l = {
          id: null,
          "class": "",
          title: "",
          titleColor: "",
          titleSize: "",
          titleLineHeight: "",
          message: "",
          messageColor: "",
          messageSize: "",
          messageLineHeight: "",
          backgroundColor: "",
          theme: "light",
          color: "",
          icon: "",
          iconText: "",
          iconColor: "",
          iconUrl: null,
          image: "",
          imageWidth: 50,
          maxWidth: null,
          zindex: null,
          layout: 1,
          balloon: !1,
          close: !0,
          closeOnEscape: !1,
          closeOnClick: !1,
          displayMode: 0,
          position: "bottomRight",
          target: "",
          targetFirst: !0,
          timeout: 5e3,
          rtl: !1,
          animateInside: !0,
          drag: !0,
          pauseOnHover: !0,
          resetOnHover: !1,
          progressBar: !0,
          progressBarColor: "",
          progressBarEasing: "linear",
          overlay: !1,
          overlayClose: !1,
          overlayColor: "rgba(0, 0, 0, 0.6)",
          transitionIn: "fadeInUp",
          transitionOut: "fadeOut",
          transitionInMobile: "fadeInUp",
          transitionOutMobile: "fadeOutDown",
          buttons: {},
          inputs: {},
          onOpening: function onOpening() {},
          onOpened: function onOpened() {},
          onClosing: function onClosing() {},
          onClosed: function onClosed() {}
        };

        if ("remove" in Element.prototype || (Element.prototype.remove = function () {
          this.parentNode && this.parentNode.removeChild(this);
        }), "function" != typeof window.CustomEvent) {
          var c = function c(t, e) {
            e = e || {
              bubbles: !1,
              cancelable: !1,
              detail: void 0
            };
            var i = document.createEvent("CustomEvent");
            return i.initCustomEvent(t, e.bubbles, e.cancelable, e.detail), i;
          };

          c.prototype = window.Event.prototype, window.CustomEvent = c;
        }

        var u = function u(t, e, i) {
          if ("[object Object]" === Object.prototype.toString.call(t)) for (var o in t) {
            Object.prototype.hasOwnProperty.call(t, o) && e.call(i, t[o], o, t);
          } else if (t) for (var n = 0, s = t.length; n < s; n++) {
            e.call(i, t[n], n, t);
          }
        },
            d = function d(t, e) {
          var i = {};
          return u(t, function (e, o) {
            i[o] = t[o];
          }), u(e, function (t, o) {
            i[o] = e[o];
          }), i;
        },
            p = function p(t) {
          var e = document.createDocumentFragment(),
              i = document.createElement("div");

          for (i.innerHTML = t; i.firstChild;) {
            e.appendChild(i.firstChild);
          }

          return e;
        },
            m = {
          move: function move(t, e, i, s) {
            var a;
            0 !== s && (t.classList.add("iziToast-dragged"), t.style.transform = "translateX(" + s + "px)", s > 0 ? (a = (180 - s) / 180) < .3 && e.hide(d(i, {
              transitionOut: "fadeOutRight",
              transitionOutMobile: "fadeOutRight"
            }), t, "drag") : (a = (180 + s) / 180) < .3 && e.hide(d(i, {
              transitionOut: "fadeOutLeft",
              transitionOutMobile: "fadeOutLeft"
            }), t, "drag"), t.style.opacity = a, a < .3 && ((o || n) && (t.style.left = s + "px"), t.parentNode.style.opacity = .3, this.stopMoving(t, null)));
          },
          startMoving: function startMoving(t, e, i, o) {
            o = o || window.event;
            var n = s ? o.touches[0].clientX : o.clientX,
                a = t.style.transform.replace("px)", ""),
                r = n - (a = a.replace("translateX(", ""));
            i.transitionIn && t.classList.remove(i.transitionIn), i.transitionInMobile && t.classList.remove(i.transitionInMobile), t.style.transition = "", s ? document.ontouchmove = function (o) {
              o.preventDefault();
              var n = (o = o || window.event).touches[0].clientX - r;
              m.move(t, e, i, n);
            } : document.onmousemove = function (o) {
              o.preventDefault();
              var n = (o = o || window.event).clientX - r;
              m.move(t, e, i, n);
            };
          },
          stopMoving: function stopMoving(t, e) {
            s ? document.ontouchmove = function () {} : document.onmousemove = function () {}, t.style.opacity = "", t.style.transform = "", t.classList.contains("iziToast-dragged") && (t.classList.remove("iziToast-dragged"), t.style.transition = "transform 0.4s ease, opacity 0.4s ease", setTimeout(function () {
              t.style.transition = "";
            }, 400));
          }
        };

        return e.setSetting = function (t, i, o) {
          e.children[t][i] = o;
        }, e.getSetting = function (t, i) {
          return e.children[t][i];
        }, e.destroy = function () {
          u(document.querySelectorAll(".iziToast-overlay"), function (t, e) {
            t.remove();
          }), u(document.querySelectorAll(".iziToast-wrapper"), function (t, e) {
            t.remove();
          }), u(document.querySelectorAll(".iziToast"), function (t, e) {
            t.remove();
          }), this.children = {}, document.removeEventListener("iziToast-opened", {}, !1), document.removeEventListener("iziToast-opening", {}, !1), document.removeEventListener("iziToast-closing", {}, !1), document.removeEventListener("iziToast-closed", {}, !1), document.removeEventListener("keyup", {}, !1), r = {};
        }, e.settings = function (t) {
          e.destroy(), r = t, l = d(l, t || {});
        }, u({
          info: {
            color: "blue",
            icon: "ico-info"
          },
          success: {
            color: "green",
            icon: "ico-success"
          },
          warning: {
            color: "orange",
            icon: "ico-warning"
          },
          error: {
            color: "red",
            icon: "ico-error"
          },
          question: {
            color: "yellow",
            icon: "ico-question"
          }
        }, function (t, i) {
          e[i] = function (e) {
            var i = d(r, e || {});
            i = d(t, i || {}), this.show(i);
          };
        }), e.progress = function (t, e, i) {
          var o = this,
              n = e.getAttribute("data-iziToast-ref"),
              s = d(this.children[n], t || {}),
              a = e.querySelector(".iziToast-progressbar div");
          return {
            start: function start() {
              void 0 === s.time.REMAINING && (e.classList.remove("iziToast-reseted"), null !== a && (a.style.transition = "width " + s.timeout + "ms " + s.progressBarEasing, a.style.width = "0%"), s.time.START = new Date().getTime(), s.time.END = s.time.START + s.timeout, s.time.TIMER = setTimeout(function () {
                clearTimeout(s.time.TIMER), e.classList.contains("iziToast-closing") || (o.hide(s, e, "timeout"), "function" == typeof i && i.apply(o));
              }, s.timeout), o.setSetting(n, "time", s.time));
            },
            pause: function pause() {
              if (void 0 !== s.time.START && !e.classList.contains("iziToast-paused") && !e.classList.contains("iziToast-reseted")) {
                if (e.classList.add("iziToast-paused"), s.time.REMAINING = s.time.END - new Date().getTime(), clearTimeout(s.time.TIMER), o.setSetting(n, "time", s.time), null !== a) {
                  var t = window.getComputedStyle(a).getPropertyValue("width");
                  a.style.transition = "none", a.style.width = t;
                }

                "function" == typeof i && setTimeout(function () {
                  i.apply(o);
                }, 10);
              }
            },
            resume: function resume() {
              void 0 !== s.time.REMAINING ? (e.classList.remove("iziToast-paused"), null !== a && (a.style.transition = "width " + s.time.REMAINING + "ms " + s.progressBarEasing, a.style.width = "0%"), s.time.END = new Date().getTime() + s.time.REMAINING, s.time.TIMER = setTimeout(function () {
                clearTimeout(s.time.TIMER), e.classList.contains("iziToast-closing") || (o.hide(s, e, "timeout"), "function" == typeof i && i.apply(o));
              }, s.time.REMAINING), o.setSetting(n, "time", s.time)) : this.start();
            },
            reset: function reset() {
              clearTimeout(s.time.TIMER), delete s.time.REMAINING, o.setSetting(n, "time", s.time), e.classList.add("iziToast-reseted"), e.classList.remove("iziToast-paused"), null !== a && (a.style.transition = "none", a.style.width = "100%"), "function" == typeof i && setTimeout(function () {
                i.apply(o);
              }, 10);
            }
          };
        }, e.hide = function (t, e, o) {
          "object" != _typeof(e) && (e = document.querySelector(e));
          var n = this,
              s = d(this.children[e.getAttribute("data-iziToast-ref")], t || {});
          s.closedBy = o || null, delete s.time.REMAINING, e.classList.add("iziToast-closing"), function () {
            var t = document.querySelector(".iziToast-overlay");

            if (null !== t) {
              var e = t.getAttribute("data-iziToast-ref"),
                  i = (e = e.split(",")).indexOf(String(s.ref));
              -1 !== i && e.splice(i, 1), t.setAttribute("data-iziToast-ref", e.join()), 0 === e.length && (t.classList.remove("fadeIn"), t.classList.add("fadeOut"), setTimeout(function () {
                t.remove();
              }, 700));
            }
          }(), s.transitionIn && e.classList.remove(s.transitionIn), s.transitionInMobile && e.classList.remove(s.transitionInMobile), i || window.innerWidth <= 568 ? s.transitionOutMobile && e.classList.add(s.transitionOutMobile) : s.transitionOut && e.classList.add(s.transitionOut);
          var a = e.parentNode.offsetHeight;
          e.parentNode.style.height = a + "px", e.style.pointerEvents = "none", (!i || window.innerWidth > 568) && (e.parentNode.style.transitionDelay = "0.2s");

          try {
            var r = new CustomEvent("iziToast-closing", {
              detail: s,
              bubbles: !0,
              cancelable: !0
            });
            document.dispatchEvent(r);
          } catch (t) {
            console.warn(t);
          }

          setTimeout(function () {
            e.parentNode.style.height = "0px", e.parentNode.style.overflow = "", setTimeout(function () {
              delete n.children[s.ref], e.parentNode.remove();

              try {
                var t = new CustomEvent("iziToast-closed", {
                  detail: s,
                  bubbles: !0,
                  cancelable: !0
                });
                document.dispatchEvent(t);
              } catch (t) {
                console.warn(t);
              }

              void 0 !== s.onClosed && s.onClosed.apply(null, [s, e, o]);
            }, 1e3);
          }, 200), void 0 !== s.onClosing && s.onClosing.apply(null, [s, e, o]);
        }, e.show = function (t) {
          var o,
              n = this,
              c = d(r, t || {});
          if ((c = d(l, c)).time = {}, null === c.id && (c.id = (o = c.title + c.message + c.color, btoa(encodeURIComponent(o)).replace(/=/g, ""))), 1 === c.displayMode || "once" == c.displayMode) try {
            if (document.querySelectorAll(".iziToast#" + c.id).length > 0) return !1;
          } catch (t) {
            console.warn("[iziToast] Could not find an element with this selector: #" + c.id + ". Try to set an valid id.");
          }
          if (2 === c.displayMode || "replace" == c.displayMode) try {
            u(document.querySelectorAll(".iziToast#" + c.id), function (t, e) {
              n.hide(c, t, "replaced");
            });
          } catch (t) {
            console.warn("[iziToast] Could not find an element with this selector: #" + c.id + ". Try to set an valid id.");
          }
          c.ref = new Date().getTime() + Math.floor(1e7 * Math.random() + 1), e.children[c.ref] = c;
          var f,
              g = {
            body: document.querySelector("body"),
            overlay: document.createElement("div"),
            toast: document.createElement("div"),
            toastBody: document.createElement("div"),
            toastTexts: document.createElement("div"),
            toastCapsule: document.createElement("div"),
            cover: document.createElement("div"),
            buttons: document.createElement("div"),
            inputs: document.createElement("div"),
            icon: c.iconUrl ? document.createElement("img") : document.createElement("i"),
            wrapper: null
          };
          g.toast.setAttribute("data-iziToast-ref", c.ref), g.toast.appendChild(g.toastBody), g.toastCapsule.appendChild(g.toast), function () {
            if (g.toast.classList.add("iziToast"), g.toast.classList.add("iziToast-opening"), g.toastCapsule.classList.add("iziToast-capsule"), g.toastBody.classList.add("iziToast-body"), g.toastTexts.classList.add("iziToast-texts"), i || window.innerWidth <= 568 ? c.transitionInMobile && g.toast.classList.add(c.transitionInMobile) : c.transitionIn && g.toast.classList.add(c.transitionIn), c["class"]) {
              var t = c["class"].split(" ");
              u(t, function (t, e) {
                g.toast.classList.add(t);
              });
            }

            var e;
            c.id && (g.toast.id = c.id), c.rtl && (g.toast.classList.add("iziToast-rtl"), g.toast.setAttribute("dir", "rtl")), c.layout > 1 && g.toast.classList.add("iziToast-layout" + c.layout), c.balloon && g.toast.classList.add("iziToast-balloon"), c.maxWidth && (isNaN(c.maxWidth) ? g.toast.style.maxWidth = c.maxWidth : g.toast.style.maxWidth = c.maxWidth + "px"), "" === c.theme && "light" === c.theme || g.toast.classList.add("iziToast-theme-" + c.theme), c.color && ("#" == (e = c.color).substring(0, 1) || "rgb" == e.substring(0, 3) || "hsl" == e.substring(0, 3) ? g.toast.style.background = c.color : g.toast.classList.add("iziToast-color-" + c.color)), c.backgroundColor && (g.toast.style.background = c.backgroundColor, c.balloon && (g.toast.style.borderColor = c.backgroundColor));
          }(), c.image && (g.cover.classList.add("iziToast-cover"), g.cover.style.width = c.imageWidth + "px", function (t) {
            try {
              return btoa(atob(t)) == t;
            } catch (t) {
              return !1;
            }
          }(c.image.replace(/ /g, "")) ? g.cover.style.backgroundImage = "url(data:image/png;base64," + c.image.replace(/ /g, "") + ")" : g.cover.style.backgroundImage = "url(" + c.image + ")", c.rtl ? g.toastBody.style.marginRight = c.imageWidth + 10 + "px" : g.toastBody.style.marginLeft = c.imageWidth + 10 + "px", g.toast.appendChild(g.cover)), c.close ? (g.buttonClose = document.createElement("button"), g.buttonClose.type = "button", g.buttonClose.classList.add("iziToast-close"), g.buttonClose.addEventListener("click", function (t) {
            t.target, n.hide(c, g.toast, "button");
          }), g.toast.appendChild(g.buttonClose)) : c.rtl ? g.toast.style.paddingLeft = "18px" : g.toast.style.paddingRight = "18px", c.progressBar && (g.progressBar = document.createElement("div"), g.progressBarDiv = document.createElement("div"), g.progressBar.classList.add("iziToast-progressbar"), g.progressBarDiv.style.background = c.progressBarColor, g.progressBar.appendChild(g.progressBarDiv), g.toast.appendChild(g.progressBar)), c.timeout && (c.pauseOnHover && !c.resetOnHover && (g.toast.addEventListener("mouseenter", function (t) {
            n.progress(c, g.toast).pause();
          }), g.toast.addEventListener("mouseleave", function (t) {
            n.progress(c, g.toast).resume();
          })), c.resetOnHover && (g.toast.addEventListener("mouseenter", function (t) {
            n.progress(c, g.toast).reset();
          }), g.toast.addEventListener("mouseleave", function (t) {
            n.progress(c, g.toast).start();
          }))), c.iconUrl ? (g.icon.setAttribute("class", "iziToast-icon"), g.icon.setAttribute("src", c.iconUrl)) : c.icon && (g.icon.setAttribute("class", "iziToast-icon " + c.icon), c.iconText && g.icon.appendChild(document.createTextNode(c.iconText)), c.iconColor && (g.icon.style.color = c.iconColor)), (c.icon || c.iconUrl) && (c.rtl ? g.toastBody.style.paddingRight = "33px" : g.toastBody.style.paddingLeft = "33px", g.toastBody.appendChild(g.icon)), c.title.length > 0 && (g.strong = document.createElement("strong"), g.strong.classList.add("iziToast-title"), g.strong.appendChild(p(c.title)), g.toastTexts.appendChild(g.strong), c.titleColor && (g.strong.style.color = c.titleColor), c.titleSize && (isNaN(c.titleSize) ? g.strong.style.fontSize = c.titleSize : g.strong.style.fontSize = c.titleSize + "px"), c.titleLineHeight && (isNaN(c.titleSize) ? g.strong.style.lineHeight = c.titleLineHeight : g.strong.style.lineHeight = c.titleLineHeight + "px")), c.message.length > 0 && (g.p = document.createElement("p"), g.p.classList.add("iziToast-message"), g.p.appendChild(p(c.message)), g.toastTexts.appendChild(g.p), c.messageColor && (g.p.style.color = c.messageColor), c.messageSize && (isNaN(c.titleSize) ? g.p.style.fontSize = c.messageSize : g.p.style.fontSize = c.messageSize + "px"), c.messageLineHeight && (isNaN(c.titleSize) ? g.p.style.lineHeight = c.messageLineHeight : g.p.style.lineHeight = c.messageLineHeight + "px")), c.title.length > 0 && c.message.length > 0 && (c.rtl ? g.strong.style.marginLeft = "10px" : 2 === c.layout || c.rtl || (g.strong.style.marginRight = "10px")), g.toastBody.appendChild(g.toastTexts), c.inputs.length > 0 && (g.inputs.classList.add("iziToast-inputs"), u(c.inputs, function (t, e) {
            g.inputs.appendChild(p(t[0])), (f = g.inputs.childNodes)[e].classList.add("iziToast-inputs-child"), t[3] && setTimeout(function () {
              f[e].focus();
            }, 300), f[e].addEventListener(t[1], function (e) {
              return (0, t[2])(n, g.toast, this, e);
            });
          }), g.toastBody.appendChild(g.inputs)), c.buttons.length > 0 && (g.buttons.classList.add("iziToast-buttons"), u(c.buttons, function (t, e) {
            g.buttons.appendChild(p(t[0]));
            var i = g.buttons.childNodes;
            i[e].classList.add("iziToast-buttons-child"), t[2] && setTimeout(function () {
              i[e].focus();
            }, 300), i[e].addEventListener("click", function (e) {
              return e.preventDefault(), (0, t[1])(n, g.toast, this, e, f);
            });
          })), g.toastBody.appendChild(g.buttons), c.message.length > 0 && (c.inputs.length > 0 || c.buttons.length > 0) && (g.p.style.marginBottom = "0"), (c.inputs.length > 0 || c.buttons.length > 0) && (c.rtl ? g.toastTexts.style.marginLeft = "10px" : g.toastTexts.style.marginRight = "10px", c.inputs.length > 0 && c.buttons.length > 0 && (c.rtl ? g.inputs.style.marginLeft = "8px" : g.inputs.style.marginRight = "8px")), g.toastCapsule.style.visibility = "hidden", setTimeout(function () {
            var t = g.toast.offsetHeight,
                e = g.toast.currentStyle || window.getComputedStyle(g.toast),
                i = e.marginTop;
            i = i.split("px"), i = parseInt(i[0]);
            var o = e.marginBottom;
            o = o.split("px"), o = parseInt(o[0]), g.toastCapsule.style.visibility = "", g.toastCapsule.style.height = t + o + i + "px", setTimeout(function () {
              g.toastCapsule.style.height = "auto", c.target && (g.toastCapsule.style.overflow = "visible");
            }, 500), c.timeout && n.progress(c, g.toast).start();
          }, 100), function () {
            var t = c.position;
            if (c.target) g.wrapper = document.querySelector(c.target), g.wrapper.classList.add("iziToast-target"), c.targetFirst ? g.wrapper.insertBefore(g.toastCapsule, g.wrapper.firstChild) : g.wrapper.appendChild(g.toastCapsule);else {
              if (-1 == a.indexOf(c.position)) return void console.warn("[iziToast] Incorrect position.\nIt can be › " + a);
              t = i || window.innerWidth <= 568 ? "bottomLeft" == c.position || "bottomRight" == c.position || "bottomCenter" == c.position ? "iziToast-wrapper-bottomCenter" : "topLeft" == c.position || "topRight" == c.position || "topCenter" == c.position ? "iziToast-wrapper-topCenter" : "iziToast-wrapper-center" : "iziToast-wrapper-" + t, g.wrapper = document.querySelector(".iziToast-wrapper." + t), g.wrapper || (g.wrapper = document.createElement("div"), g.wrapper.classList.add("iziToast-wrapper"), g.wrapper.classList.add(t), document.body.appendChild(g.wrapper)), "topLeft" == c.position || "topCenter" == c.position || "topRight" == c.position ? g.wrapper.insertBefore(g.toastCapsule, g.wrapper.firstChild) : g.wrapper.appendChild(g.toastCapsule);
            }
            isNaN(c.zindex) ? console.warn("[iziToast] Invalid zIndex.") : g.wrapper.style.zIndex = c.zindex;
          }(), c.overlay && (null !== document.querySelector(".iziToast-overlay.fadeIn") ? (g.overlay = document.querySelector(".iziToast-overlay"), g.overlay.setAttribute("data-iziToast-ref", g.overlay.getAttribute("data-iziToast-ref") + "," + c.ref), isNaN(c.zindex) || null === c.zindex || (g.overlay.style.zIndex = c.zindex - 1)) : (g.overlay.classList.add("iziToast-overlay"), g.overlay.classList.add("fadeIn"), g.overlay.style.background = c.overlayColor, g.overlay.setAttribute("data-iziToast-ref", c.ref), isNaN(c.zindex) || null === c.zindex || (g.overlay.style.zIndex = c.zindex - 1), document.querySelector("body").appendChild(g.overlay)), c.overlayClose ? (g.overlay.removeEventListener("click", {}), g.overlay.addEventListener("click", function (t) {
            n.hide(c, g.toast, "overlay");
          })) : g.overlay.removeEventListener("click", {})), function () {
            if (c.animateInside) {
              g.toast.classList.add("iziToast-animateInside");
              var t = [200, 100, 300];
              "bounceInLeft" != c.transitionIn && "bounceInRight" != c.transitionIn || (t = [400, 200, 400]), c.title.length > 0 && setTimeout(function () {
                g.strong.classList.add("slideIn");
              }, t[0]), c.message.length > 0 && setTimeout(function () {
                g.p.classList.add("slideIn");
              }, t[1]), (c.icon || c.iconUrl) && setTimeout(function () {
                g.icon.classList.add("revealIn");
              }, t[2]);
              var e = 150;
              c.buttons.length > 0 && g.buttons && setTimeout(function () {
                u(g.buttons.childNodes, function (t, i) {
                  setTimeout(function () {
                    t.classList.add("revealIn");
                  }, e), e += 150;
                });
              }, c.inputs.length > 0 ? 150 : 0), c.inputs.length > 0 && g.inputs && (e = 150, u(g.inputs.childNodes, function (t, i) {
                setTimeout(function () {
                  t.classList.add("revealIn");
                }, e), e += 150;
              }));
            }
          }(), c.onOpening.apply(null, [c, g.toast]);

          try {
            var v = new CustomEvent("iziToast-opening", {
              detail: c,
              bubbles: !0,
              cancelable: !0
            });
            document.dispatchEvent(v);
          } catch (t) {
            console.warn(t);
          }

          setTimeout(function () {
            g.toast.classList.remove("iziToast-opening"), g.toast.classList.add("iziToast-opened");

            try {
              var t = new CustomEvent("iziToast-opened", {
                detail: c,
                bubbles: !0,
                cancelable: !0
              });
              document.dispatchEvent(t);
            } catch (t) {
              console.warn(t);
            }

            c.onOpened.apply(null, [c, g.toast]);
          }, 1e3), c.drag && (s ? (g.toast.addEventListener("touchstart", function (t) {
            m.startMoving(this, n, c, t);
          }, !1), g.toast.addEventListener("touchend", function (t) {
            m.stopMoving(this, t);
          }, !1)) : (g.toast.addEventListener("mousedown", function (t) {
            t.preventDefault(), m.startMoving(this, n, c, t);
          }, !1), g.toast.addEventListener("mouseup", function (t) {
            t.preventDefault(), m.stopMoving(this, t);
          }, !1))), c.closeOnEscape && document.addEventListener("keyup", function (t) {
            27 == (t = t || window.event).keyCode && n.hide(c, g.toast, "esc");
          }), c.closeOnClick && g.toast.addEventListener("click", function (t) {
            n.hide(c, g.toast, "toast");
          }), n.toast = g.toast;
        }, e;
      }(), void 0 === (s = "function" == typeof o ? o.apply(e, n) : o) || (t.exports = s);
    }).call(this, i(6));
  }, function (t, e, i) {
    t.exports = i(5);
  }, function (t, e, i) {
    "use strict";

    i.r(e), i.d(e, "devMode", function () {
      return p;
    }), i.d(e, "default", function () {
      return m;
    }), i.d(e, "install", function () {
      return f;
    });
    var o = i(2),
        n = i.n(o),
        s = i(1),
        a = i.n(s),
        r = i(0),
        l = i.n(r),
        c = i(3),
        u = i.n(c);

    function d(t, e) {
      var i = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(t);
        e && (o = o.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), i.push.apply(i, o);
      }

      return i;
    }

    function p() {
      return !1;
    }

    var m = function () {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        n()(this, t), l()(this, "_izi", u.a), l()(this, "accessorName", "toast"), l()(this, "initialized", !1);
        this.options = function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var i = null != arguments[e] ? arguments[e] : {};
            e % 2 ? d(i, !0).forEach(function (e) {
              l()(t, e, i[e]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : d(i).forEach(function (e) {
              Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
            });
          }

          return t;
        }({}, {
          zindex: 99999,
          layout: 1,
          balloon: !1,
          close: !0,
          closeOnEscape: !1,
          rtl: !1,
          position: "bottomRight",
          timeout: 5e3,
          animateInside: !0,
          drag: !0,
          pauseOnHover: !0,
          resetOnHover: !1,
          transitionIn: "fadeInUp",
          transitionOut: "fadeOut",
          transitionInMobile: "fadeInUp",
          transitionOutMobile: "fadeOutDown",
          buttons: {},
          inputs: {},
          onOpening: function onOpening() {},
          onOpened: function onOpened() {},
          onClosing: function onClosing() {},
          onClosed: function onClosed() {}
        }, {}, e), this._izi.settings(this.options);
      }

      return a()(t, null, [{
        key: "_checkParams",
        value: function value(t, e, i) {
          var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
              n = o ? " Method signature: ".concat(o, "(message: string, title: string, options: IzitoastOptions)") : "";
          if (!t || t.constructor !== String) throw "Message must be a string.".concat(n);
          if (e && e.constructor !== String) throw "Title must be a string.".concat(n);
          if (i && i.constructor !== Object) throw "Options must be a object.".concat(n);
        }
      }, {
        key: "_checkEventNames",
        value: function value(t) {
          if (!t || t.constructor !== String) throw "Event Name must be a string";
          if ("iziToast-open" !== t && "iziToast-close" !== t) throw "Event Name has only two possible values: iziToast-open or iziToast-close";
        }
      }, {
        key: "_initToast",
        value: function value(t) {
          return t && t.constructor !== String && (t = document.querySelector(t)), t && t.constructor === HTMLDivElement || (t = document.querySelector(".iziToast")), t;
        }
      }, {
        key: "_validateOptions",
        value: function value(t) {
          if (t && t.constructor !== Object) throw "Options must be a object";
        }
      }, {
        key: "_validateCallback",
        value: function value(t) {
          if (t && t.constructor !== Function) throw "Callback must be a function";
        }
      }]), a()(t, [{
        key: "init",
        value: function value(t) {
          this.initialized || (this.initialized = !0);
        }
      }, {
        key: "show",
        value: function value(e) {
          var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          t._checkParams(e, i, o, "show"), this._izi.show(Object.assign({}, o, {
            message: e,
            title: i
          }));
        }
      }, {
        key: "hide",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
              i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          e = t._initToast(e), t._validateOptions(i), this._izi.hide(i, e);
        }
      }, {
        key: "progress",
        value: function value(e) {
          var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function () {};
          return e = t._initToast(e), t._validateOptions(i), t._validateCallback(o), this._izi.progress(e, i, o);
        }
      }, {
        key: "destroy",
        value: function value() {
          this._izi.destroy();
        }
      }, {
        key: "info",
        value: function value(e) {
          var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          t._checkParams(e, i, o, "info"), this._izi.info(Object.assign({}, o, {
            message: e,
            title: i
          }));
        }
      }, {
        key: "success",
        value: function value(e) {
          var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          t._checkParams(e, i, o, "success"), this._izi.success(Object.assign({}, o, {
            message: e,
            title: i
          }));
        }
      }, {
        key: "warning",
        value: function value(e) {
          var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          t._checkParams(e, i, o, "warning"), this._izi.warning(Object.assign({}, o, {
            message: e,
            title: i
          }));
        }
      }, {
        key: "error",
        value: function value(e) {
          var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          t._checkParams(e, i, o, "error"), this._izi.error(Object.assign({}, o, {
            message: e,
            title: i
          }));
        }
      }, {
        key: "question",
        value: function value(e) {
          var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          t._checkParams(e, i, o, "question"), this._izi.question(Object.assign({}, o, {
            message: e,
            title: i
          }));
        }
      }, {
        key: "on",
        value: function value(e, i) {
          t._checkEventNames(e), t._validateCallback(i), document.addEventListener(e, i);
        }
      }, {
        key: "off",
        value: function value(e) {
          var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {};
          t._checkEventNames(e), document.removeEventListener(e, i);
        }
      }]), t;
    }();

    function f(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      if (e && e.constructor !== Object) throw "Options must be a object";

      if (!f.installed || !t) {
        var i = new m(e);
        Object.defineProperty(t.prototype, i.accessorName, {
          get: function get() {
            return i;
          }
        }), t.mixin({
          beforeCreate: function beforeCreate() {
            var e = this.$options.parent,
                o = null;
            e && e.__$VueIziToastInstance ? (o = e.__$VueIziToastInstance).init(t) : o = i, o && (this.__$VueIziToastInstance = o, this["$".concat(o.accessorName)] = o);
          }
        }), f.installed = !0;
      }
    }

    m.install = f, "undefined" != typeof window && window.Vue && window.Vue.use(m);
  }, function (t, e) {
    var i;

    i = function () {
      return this;
    }();

    try {
      i = i || new Function("return this")();
    } catch (t) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (i = window);
    }

    t.exports = i;
  }]);
});